<template>
    <Head :title="__('List of users')"/>

    <BreezeDashboardLayout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                {{ __('List of users') }}
            </h2>
        </template>

        <notification v-if="success" color="success">
            {{ success }}
        </notification>

        <card-component :title="__('Users List')" :icon="mdiListStatus" has-table
                        :header-icon="mdiAccountPlusOutline"
                        :header-text="__('Create user')"
                        @headerIconClick="$inertia.visit(route('users.create'))">
            <users-table :items="users" />
        </card-component>
    </BreezeDashboardLayout>
</template>


<script>
import BreezeDashboardLayout from '@/Layouts/Dashboard'
import CardComponent from '@/Components/Dashboard/CardComponent'
import Notification from '@/Components/Dashboard/Notification'
import {Head} from '@inertiajs/inertia-vue3';
import {
    mdiListStatus,
    mdiAccountPlusOutline
} from '@mdi/js'
import Field from '@/Components/Dashboard/Field'
import Control from '@/Components/Dashboard/Control'
import CheckRadioPicker from '@/Components/Dashboard/CheckRadioPicker'
import JbButton from '@/Components/Dashboard/JbButton'
import JbButtons from '@/Components/Dashboard/JbButtons'
import UsersTable from "@/Components/Dashboard/UsersTable"

export default {
    components: {
        UsersTable,
        BreezeDashboardLayout,
        Head,
        CardComponent,
        Notification,
        Field,
        Control,
        CheckRadioPicker,
        JbButton,
        JbButtons
    },
    props: {
        success: String,
        users: Object
    },
    setup() {
        return {
            mdiListStatus,
            mdiAccountPlusOutline
        }
    }
}
</script>
